module.exports = __webpack_public_path__ + "img/108.d53f354d.jpg";